// extracted by mini-css-extract-plugin
module.exports = {"nav":"menu-module--nav--1edJz","ul":"menu-module--ul--39S9x","link":"menu-module--link--3zg_R","activeLink":"menu-module--activeLink--1BIdu"};